var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "Layer_1",
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0m7.51 14.03c0 1.93-1.56 3.49-3.49 3.49H7.98c-1.93 0-3.49-1.56-3.49-3.49v-3.94c0-1.93 1.56-3.49 3.49-3.49h8.05c1.93 0 3.49 1.56 3.49 3.49v3.94Z",
  className: "cls-1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m15.25 12.06-4.91 2.81V9.11z",
  className: "cls-1"
})));
export default SvgYoutube;